import type { InsuranceType } from './types'
import { AnalyticsActionTypes } from './types'

const { SET_IS_QUOTE_REQUESTED_EVENT_SENT } = AnalyticsActionTypes

export const setIsQuoteRequestedEventSent = ({
  insuranceType,
  isQuoteRequestedEventSent,
}: {
  insuranceType: InsuranceType,
  isQuoteRequestedEventSent: boolean,
}): Function => (dispatch: Function): void => {
  dispatch({
    type: SET_IS_QUOTE_REQUESTED_EVENT_SENT,
    payload: {
      insuranceType,
      isQuoteRequestedEventSent,
    },
  })
}
